webpackJsonp([100],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var settings = {
    url: '',
    timeout: 60000,
    method: 'get',
    baseURL: '',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    params: {},
    transformResponse: [function (data) {
        // Do whatever you want to transform the data
        return data;
    }],
    withCredentials: false, // default
    responseType: 'json' // default

};
function request(data) {
    var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(settings, data);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.request(config);
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isIphone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return thirdParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isWechat; });
/* unused harmony export errorImg */
/* unused harmony export getWxtoken */
/* unused harmony export clearCookie */
/* unused harmony export getThirdParty */
/* unused harmony export px2px */
/* unused harmony export getRandom */
/* harmony export (immutable) */ __webpack_exports__["h"] = valideName;
/* harmony export (immutable) */ __webpack_exports__["g"] = validePhone;
/* harmony export (immutable) */ __webpack_exports__["k"] = valideMail;
/* harmony export (immutable) */ __webpack_exports__["b"] = cutHeadImg;
/* harmony export (immutable) */ __webpack_exports__["j"] = dateFilter;
/* harmony export (immutable) */ __webpack_exports__["i"] = toDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = isArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_js__ = __webpack_require__(23);



var isAndroid = /android/gi.test(navigator.appVersion);
var isIphone = /iphone/gi.test(navigator.appVersion);
var thirdParty = getThirdParty();
// isWechat
var isWechat = /micromessenger/.test(navigator.userAgent.toLowerCase()) ? true : false;
// 图片加载失败
function errorImg(img) {
    img.src = "";
    img.onerror = null;
}

// 获取微信分享token
function getWxtoken() {
    if (isWechat) {
        var config = {
            url: '/jsapi'
        };
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request_js__["a" /* request */])(config);
    }
}

function clearCookie(item) {
    __WEBPACK_IMPORTED_MODULE_1__cookie_js__["a" /* default */].set(item, '', {
        expires: 0,
        path: '/'
    });
}

// 同步获取环境参数
function getThirdParty() {
    var thirdParty = '';
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        thirdParty = 'wechat';
    } else {}
    return thirdParty;
}

/**
 * [px2px 750pxUE图下对应的px值转换为实际设备下展示的px值]
 * @param  {[number]} px    [750px下对应的px值]
 * @param  {[number]} base = 75            [默认基于750px进行转换]
 * @return {[number]}       [实际展示的px值]
 */
function px2px(px) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 75;

    return fxtflex.rem2px(fxtflex.px2rem(px, base));
};

/**
 * [getRandom 获取【0，length-1)]之间的整数随机数
 * @param  {[number]} length: 2             [随机数个数]
 * @return {[number]}         [整数随机数，默认返回0或1]
 */
function getRandom(length) {
    return Math.floor(Math.random() * length);
};
/**
 * [valideName 验证姓名长度]
 * @param  {[string]} val    [name 字串]
 * @param  {[number]} length [限制长度]
 * @return {[boolean]}        [Boolean]
 */
function valideName(val, length) {
    if (val) {
        if (val.length > length) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}
/**
 * [validePhone 常规手机号验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
function validePhone(val) {
    var reg = /(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/;
    return reg.test(val);
}
/**
 * [valideMail 常规邮箱验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
function valideMail(val) {
    var reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
    return reg.test(val);
}
/**
 * [cutHeadImg 头像阿里云方图裁剪]
 * @param  {[string]} url [用户头像]
 * @return {[string]}     [加入裁剪参数的url]
 */
function cutHeadImg(obj) {
    obj.width = obj.width ? obj.width : 100;
    obj.height = obj.height ? obj.height : 100;
    if (obj.url) {
        if (obj.url.indexOf('?') >= 0) {
            // & 拼接
            if (obj.url.indexOf('x-oss-process=image/resize,m_fill' >= 0)) {
                return obj.url;
            }
            return obj.url + '&x-oss-process=image/resize,m_fill,h_' + obj.height + ',w_' + obj.width;
        } else {
            // ? 拼接
            return obj.url + '?x-oss-process=image/resize,m_fill,h_' + obj.height + ',w_' + obj.width;
        }
    }
    return '';
}
// dateFilter for js stamp
function dateFilter(value, fmt) {
    if (value) {
        var date = new Date(value);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return fmt;
    } else {
        return '   -';
    }
}

/**
 * [时间戳转换为时间]
 * @param  {[String]} timeStamp [以毫秒为单位]
 * @return {[Array]}           [年，月，日，时，分，秒]
 */
function toDate(timeStamp) {
    var currentDate = new Date(Number(timeStamp));
    var currentTime = currentDate.getTime();
    var currentHour = currentDate.getHours();
    var currentMinute = currentDate.getMinutes();
    var currentSeconds = currentDate.getSeconds();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentDay = currentDate.getDate();
    return [currentYear, currentMonth + 1, currentDay, currentHour, currentMinute, currentSeconds];
}

/**
 * [判断是否为数组]
 * @param  {[Object]} obj  任意对象 数组、字符串，对象等
 * @return {[Boolean]}     
 */
function isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _isValidKey = function _isValidKey(key) {
    return new RegExp("^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$").test(key);
};

var getRaw = function getRaw(key) {
    if (_isValidKey(key)) {
        var reg = new RegExp("(^| )" + key + "=([^;]*)(;|\x24)"),
            result = reg.exec(document.cookie);

        if (result) {
            return result[2] || null;
        }
    }

    return null;
};

var get = function get(key) {
    var value = getRaw(key);
    if ('string' == typeof value) {
        value = decodeURIComponent(value);
        return value;
    }
    return null;
};

var setRaw = function setRaw(key, value, options) {
    if (!_isValidKey(key)) {
        return;
    }

    options = options || {};

    // 计算cookie过期时间
    var expires = options.expires;
    if ('number' == typeof options.expires) {
        expires = new Date();
        expires.setTime(expires.getTime() + options.expires);
    }

    document.cookie = key + "=" + value + (options.path ? "; path=" + options.path : "") + (expires ? "; expires=" + expires.toGMTString() : "") + (options.domain ? "; domain=" + options.domain : "") + (options.secure ? "; secure" : '');
};

var remove = function remove(key, options) {
    options = optionalions || {};
    options.expires = new Date(0);
    setRaw(key, '', options);
};

var set = function set(key, value, options) {
    setRaw(key, encodeURIComponent(value), options);
};
var Cookie = {};
/* harmony default export */ __webpack_exports__["a"] = ({
    getRaw: getRaw,
    get: get,
    remove: remove,
    setRaw: setRaw,
    set: set
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = offLineLister;
/* unused harmony export connectNetType */
/* harmony export (immutable) */ __webpack_exports__["c"] = wxNetType;
/* unused harmony export netTypeChange */
/* harmony export (immutable) */ __webpack_exports__["b"] = isOnline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);



var setting = {
    type: '', // 网络类型
    connect: window.navigator.connection || null,
    ua: window.navigator.userAgent,
    isOnline: window.navigator.onLine,
    offLineHanler: function offLineHanler() {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您目前处于无网络状态，请检查网络！');
    },
    typeChangeHandler: function typeChangeHandler() {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您的网络有变化~');
    }
};
function offLineLister() {
    var oldOnLineType = window.navigator.onLine;
    if (setting.connect) {
        setting.connect.onchange = function () {
            document.dispatchEvent(new Event('network_change'));
        };
    } else {
        setInterval(function () {
            if (oldOnLineType !== window.navigator.onLine) {
                oldOnLineType = window.navigator.onLine;
                document.dispatchEvent(new Event('network_change'));
            }
        }, 2000);
    }
};
function connectNetType() {
    // 只能用于移动设备网络状态检测
    // bluetooth
    // cellular
    // ethernet
    // none
    // wifi
    // other
    // unknown
    var connection = setting.connect;
    if (connection) {
        alert(connection.type);
        return connection.type;
    } else {}
};
function wxNetType() {
    // debugger
    if (/NetType/.test(setting.ua)) {
        var netType = setting.ua.match(/NetType\/(\S*)/);
        if (netType.indexOf('WIFI') >= 0) {
            return 'wifi';
        } else if (netType.indexOf('4G') >= 0) {
            return '4g';
        } else if (netType.indexOf('3G') >= 0) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您当前的网络是3g哦~建议打开WiFi网络录音效果更佳');
            return '3g';
        } else if (netType.indexOf('2G') >= 0) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您当前的网络是2g哦，建议打开WiFi网络录音效果更佳');
            return '2g';
        } else {
            if (!setting.isOnline) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('网络异常，请检查后重试~');
                return 'none';
            }
        }
    }
    return '';
};
function netTypeChange() {
    setting.connect && setting.connect.addEventListener('ontypechange', function (e) {});
}

function isOnline() {
    return window.navigator.onLine;
}

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    lexam_status: {
        playing: false, // L1-3问答播放状态
        cur_src: '' // 目前播放的url
    },
    mexam_status: {
        playing: false, // L1-3问答播放状态
        cur_src: '' // 目前播放的url
    }
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    url: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    recordModel: []
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    inited: false,
    status: 0, // 是否打过卡，0：未打卡；1：已打卡；2：无可用
    share_id: '',
    question: [], // 问答
    question_pages: 0, //问答总页数
    storys: [], // 跟读、阅读
    storys_pages: 0, //跟读、阅读总页数
    demo_audio: '',
    period_id: 0, //阶段
    day_id: 0, //天数
    total_days: 0, //总天数
    series_day: 0, //连续的天数
    during: 0, //音频时间  以秒为单位
    cover_img: '',
    cover_title: '',
    cover_text: '',
    cover_audio: '',
    user_weixin_audio: '', // 录音的serverId
    user_audio: '', //打卡后mp3
    training: {}, // 打卡信息
    loves: '', // 点赞数
    higher: {} //l7-l9课程
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    inited: false,
    status: 0, // 是否打过卡，0：未打卡；1：已打卡；2：无可用
    // share_id: '',
    question: [], // 问答
    question_pages: 0, //问答总页数
    storys: [], // 跟读、阅读
    storys_pages: 0, //跟读、阅读总页数
    // demo_audio: '',
    period_id: 0, //阶段
    day_id: 0, //天数
    total_days: 0, //总天数
    // series_day: 0, //连续的天数
    // during: 0, //音频时间  以秒为单位
    cover_img: '',
    cover_title: '',
    cover_text: '',
    cover_audio: ''
    // user_weixin_audio: '', // 录音的serverId
    // training: {}, // 打卡信息
    // loves: '', // 点赞数
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    commentDate: [] // 有评价的所有日期
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    isShowGendu: true,
    isShowWenda: true,
    lastShow: '' // 上一次到哪个内容了, 包括yuedu gendu wenda 三个
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    inited: false,
    on_training: false,
    is_new: true,
    user_state: 0, // 0 未关注，1已关注
    nickname: "", //孩子姓名
    icon: "", // 头像
    birthday: "",
    age: "",
    remind_time: "",
    point: "",
    city: "",
    city_id: "",
    province_id: "",
    province: "",
    uid: "",
    complete: ""
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    inited: false,
    on_training: false,
    is_new: true,
    user_state: 0, // 0 未关注，1已关注
    nickname: "abc", //孩子姓名
    icon: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/wechat/2017/12/13/27151121513155768.jpg?x-oss-process=image/resize,m_fill,h_100,w_100", // 头像
    birthday: "1420041600",
    age: "",
    remind_time: "00:00",
    point: "130",
    city: "北京",
    city_id: "1",
    province_id: "1",
    province: "北京",
    uid: "375",
    complete: "true"
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    uploadimg: '',
    bless: {
        name: '',
        blessing: ''
    },
    mergeimg: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    lAnswers: []
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    recordModel: []
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    mAnswers: []
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    mrecordModel: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    provinces: '', // 省市信息
    provincesIdMap: {}, // 省id map
    citysIdMap: {}, // 市id map
    grades: '' // 年级信息
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    shuerteGame: {
        type: '1', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    attentionGame: {
        type: '2', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0, 0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    findSheepGame: {
        type: '3', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    rankGame: {
        type: '4', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    },
    regulaGame: {
        type: '5', // type: 1—舒尔特方格,2— 你看到了几块小熊饼干, 3— 小海马, 4— 线索排序, 5— 看图找规律
        total_time: '', // //总花费时长
        answer: '0, 0, 0', // 1: 正确；-1: 错误 ;1,-1,1,-1,1,-1; 0 未作答
        is_timeout: false // //是否超时, true: 超时
    }
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    login: {
        phone: '',
        headimg: ''
    }
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    senvenPlayer_status: {
        playing: false, // 播放状态
        cur_src: '' // 目前播放的url
    }
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    "is_new": true,
    "user_state": 0, // 0 未关注，1已关注
    "name": "", //孩子姓名
    "headimg": "", // 头像
    "phone": "", //家长手机号 
    "phone_code": "",
    "province_id": "", //省份id，获取省份和城市见/wechat/api/city接口 
    "province_name": "",
    "city_id": "", //城市id
    "city_name": "",
    "area_code": "",
    "sex": "", //性别 1男 2女 
    "grade": "", //在读年级 
    "email": "", //邮箱 
    "uid": "", //培优账号（如有）
    "stu_num": "", // 学员编号
    "birth": "", //生日
    "py_area_code": "", //培优地区码
    "py_area_name": "", //配有地区名称
    "py_real_name": "", //培优真实姓名
    "py_grade": "", //培优年级
    "stu_id": "",
    "state": "", //是否关注公众号
    "is_complete": false // 是否绑定信息
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    id: '',
    openId: '', // wx openid
    token: '', // wx token
    wxname: '',
    wxnickName: '',
    wxavatar: '',
    wxemail: '',
    wxsex: '',
    wxcity: '',
    wxprovince: '',
    wxcountry: '',
    appId: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Unfound__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Unfound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Unfound__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);




// l1-l3
var Lower = function Lower(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__(266));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// l7-l9
var Higher = function Higher(r) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
        return r(__webpack_require__(250));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 表达
var Expression = function Expression(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__(247));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 用户中心-首页
var UserCenter = function UserCenter(r) {
    return __webpack_require__.e/* require.ensure */(95).then((function () {
        return r(__webpack_require__(316));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};;
var UserHome = function UserHome(r) {
    return __webpack_require__.e/* require.ensure */(67).then((function () {
        return r(__webpack_require__(304));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-手机号登录
var UserPhoneLogin = function UserPhoneLogin(r) {
    return __webpack_require__.e/* require.ensure */(71).then((function () {
        return r(__webpack_require__(307));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心作业答案
var Answer = function Answer(r) {
    return __webpack_require__.e/* require.ensure */(76).then((function () {
        return r(__webpack_require__(287));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-学而思账号登录
var UserXesLogin = function UserXesLogin(r) {
    return __webpack_require__.e/* require.ensure */(86).then((function () {
        return r(__webpack_require__(310));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 绑定手机号
var UserBindPhone = function UserBindPhone(r) {
    return __webpack_require__.e/* require.ensure */(72).then((function () {
        return r(__webpack_require__(301));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-完善信息
var CompleteInfo = function CompleteInfo(r) {
    return __webpack_require__.e/* require.ensure */(41).then((function () {
        return r(__webpack_require__(289));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-表单
var UserInfo = function UserInfo(r) {
    return __webpack_require__.e/* require.ensure */(68).then((function () {
        return r(__webpack_require__(305));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//用户中心-表单详细信息
var UserSex = function UserSex(r) {
    return __webpack_require__.e/* require.ensure */(84).then((function () {
        return r(__webpack_require__(308));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserSwitchPhone = function UserSwitchPhone(r) {
    return __webpack_require__.e/* require.ensure */(70).then((function () {
        return r(__webpack_require__(309));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserMail = function UserMail(r) {
    return __webpack_require__.e/* require.ensure */(87).then((function () {
        return r(__webpack_require__(306));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//切换学员编号
var SwitchStuNum = function SwitchStuNum(r) {
    return __webpack_require__.e/* require.ensure */(88).then((function () {
        return r(__webpack_require__(299));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const UserNum = r => require.ensure([], () => r(require('@/views/user/userNum/userNum')), 'UserNum');
//资料下载
var UserDocument = function UserDocument(r) {
    return __webpack_require__.e/* require.ensure */(80).then((function () {
        return r(__webpack_require__(302));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserDownload = function UserDownload(r) {
    return __webpack_require__.e/* require.ensure */(79).then((function () {
        return r(__webpack_require__(303));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DownloadSelect = function DownloadSelect(r) {
    return __webpack_require__.e/* require.ensure */(75).then((function () {
        return r(__webpack_require__(291));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DocQrCode = function DocQrCode(r) {
    return __webpack_require__.e/* require.ensure */(81).then((function () {
        return r(__webpack_require__(290));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//考试
var ExamCard = function ExamCard(r) {
    return __webpack_require__.e/* require.ensure */(49).then((function () {
        return r(__webpack_require__(292));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamInfo = function ExamInfo(r) {
    return __webpack_require__.e/* require.ensure */(53).then((function () {
        return r(__webpack_require__(293));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamNotice = function ExamNotice(r) {
    return __webpack_require__.e/* require.ensure */(51).then((function () {
        return r(__webpack_require__(294));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamQuery = function ExamQuery(r) {
    return __webpack_require__.e/* require.ensure */(44).then((function () {
        return r(__webpack_require__(295));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ScheduleQuery = function ScheduleQuery(r) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
        return r(__webpack_require__(298));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ClassList = function ClassList(r) {
    return __webpack_require__.e/* require.ensure */(55).then((function () {
        return r(__webpack_require__(288));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TestList = function TestList(r) {
    return __webpack_require__.e/* require.ensure */(50).then((function () {
        return r(__webpack_require__(300));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var IfsReport = function IfsReport(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__(297));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Follow = function Follow(r) {
    return __webpack_require__.e/* require.ensure */(89).then((function () {
        return r(__webpack_require__(296));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// h5运营活动
var Huodong = function Huodong(r) {
    return __webpack_require__.e/* require.ensure */(99).then((function () {
        return r(__webpack_require__(313));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 活动报名
// const SignUp = r => require.ensure([], () => r(require('@/views/activity/signUp/signUp')), 'SignUp');
var SelectSpace = function SelectSpace(r) {
    return __webpack_require__.e/* require.ensure */(52).then((function () {
        return r(__webpack_require__(243));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Content = function Content(r) {
    return __webpack_require__.e/* require.ensure */(66).then((function () {
        return r(__webpack_require__(242));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const XesLogin = r => require.ensure([], () => r(require('@/views/activity/xesLogin/xesLogin')), 'XesLogin');
// 本地图文
var Imagetext = function Imagetext(r) {
    return __webpack_require__.e/* require.ensure */(98).then((function () {
        return r(__webpack_require__(314));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Wximagetext = function Wximagetext(r) {
    return __webpack_require__.e/* require.ensure */(82).then((function () {
        return r(__webpack_require__(281));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Pcimagetext = function Pcimagetext(r) {
    return __webpack_require__.e/* require.ensure */(90).then((function () {
        return r(__webpack_require__(280));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const XesLogin = r => require.ensure([], () => r(require('@/views/activity/xesLogin/xesLogin')), 'XesLogin');
var ActXesLogin = function ActXesLogin(r) {
    return __webpack_require__.e/* require.ensure */(92).then((function () {
        return r(__webpack_require__(241));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActPhoneLogin = function ActPhoneLogin(r) {
    return __webpack_require__.e/* require.ensure */(73).then((function () {
        return r(__webpack_require__(240));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActBindPhone = function ActBindPhone(r) {
    return __webpack_require__.e/* require.ensure */(74).then((function () {
        return r(__webpack_require__(238));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActCompInfo = function ActCompInfo(r) {
    return __webpack_require__.e/* require.ensure */(42).then((function () {
        return r(__webpack_require__(239));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 21天训练营
var Habit = function Habit(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(312));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Introduce = function Introduce(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(263));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var IntroduceMore = function IntroduceMore(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(264));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Center = function Center(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(334));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Card = function Card(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(272));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CardShare = function CardShare(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(273));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Journal = function Journal(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(274));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamsResult = function ExamsResult(r) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
        return r(__webpack_require__(244));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GuideIllustration = function GuideIllustration(r) {
    return __webpack_require__.e/* require.ensure */(63).then((function () {
        return r(__webpack_require__(248));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Sleep = function Sleep(r) {
    return __webpack_require__.e/* require.ensure */(56).then((function () {
        return r(__webpack_require__(271));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ChengYu = function ChengYu(r) {
    return __webpack_require__.e/* require.ensure */(65).then((function () {
        return r(__webpack_require__(245));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 助力活动
var zhuli = function zhuli(r) {
    return __webpack_require__.e/* require.ensure */(97).then((function () {
        return r(__webpack_require__(342));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var list = function list(r) {
    return __webpack_require__.e/* require.ensure */(77).then((function () {
        return r(__webpack_require__(340));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Detail = function Detail(r) {
    return __webpack_require__.e/* require.ensure */(78).then((function () {
        return r(__webpack_require__(338));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Address = function Address(r) {
    return __webpack_require__.e/* require.ensure */(45).then((function () {
        return r(__webpack_require__(337));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Share = function Share(r) {
    return __webpack_require__.e/* require.ensure */(54).then((function () {
        return r(__webpack_require__(341));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExchangePrize = function ExchangePrize(r) {
    return __webpack_require__.e/* require.ensure */(93).then((function () {
        return r(__webpack_require__(339));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GuShi = function GuShi(r) {
    return __webpack_require__.e/* require.ensure */(62).then((function () {
        return r(__webpack_require__(249));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CiYu = function CiYu(r) {
    return __webpack_require__.e/* require.ensure */(64).then((function () {
        return r(__webpack_require__(246));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var KaiDiKe = function KaiDiKe(r) {
    return __webpack_require__.e/* require.ensure */(57).then((function () {
        return r(__webpack_require__(265));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//上海故事大赛
var Video = function Video(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(335));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var VideoList = function VideoList(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(336));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 大赛
var Lecturer = function Lecturer(r) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
        return r(__webpack_require__(323));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LecturerList = function LecturerList(r) {
    return __webpack_require__.e/* require.ensure */(31).then((function () {
        return r(__webpack_require__(324));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureShare = function lectureShare(r) {
    return __webpack_require__.e/* require.ensure */(39).then((function () {
        return r(__webpack_require__(320));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureTime = function lectureTime(r) {
    return __webpack_require__.e/* require.ensure */(35).then((function () {
        return r(__webpack_require__(322));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureSubjects = function lectureSubjects(r) {
    return __webpack_require__.e/* require.ensure */(36).then((function () {
        return r(__webpack_require__(321));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var videoUpload = function videoUpload(r) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
        return r(__webpack_require__(325));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 上海新版萌娃
var Lecturersh = function Lecturersh(r) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
        return r(__webpack_require__(329));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LecturerListsh = function LecturerListsh(r) {
    return __webpack_require__.e/* require.ensure */(30).then((function () {
        return r(__webpack_require__(330));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureSharesh = function lectureSharesh(r) {
    return __webpack_require__.e/* require.ensure */(38).then((function () {
        return r(__webpack_require__(326));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureTimesh = function lectureTimesh(r) {
    return __webpack_require__.e/* require.ensure */(33).then((function () {
        return r(__webpack_require__(328));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lectureSubjectssh = function lectureSubjectssh(r) {
    return __webpack_require__.e/* require.ensure */(34).then((function () {
        return r(__webpack_require__(327));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var videoUploadsh = function videoUploadsh(r) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
        return r(__webpack_require__(331));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//广州故事大赛
//广州故事大赛
var Guangzhou = function Guangzhou(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(319));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GuangzhouList = function GuangzhouList(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(318));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var afterShare = function afterShare(r) {
    return __webpack_require__.e/* require.ensure */(40).then((function () {
        return r(__webpack_require__(317));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 21天运营活动
var Christmas = function Christmas(r) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
        return r(__webpack_require__(251));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ChristmasShare = function ChristmasShare(r) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
        return r(__webpack_require__(252));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var kaidikeBook = function kaidikeBook(r) {
    return __webpack_require__.e/* require.ensure */(43).then((function () {
        return r(__webpack_require__(256));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Prize = function Prize(r) {
    return __webpack_require__.e/* require.ensure */(32).then((function () {
        return r(__webpack_require__(259));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PrizeShare = function PrizeShare(r) {
    return __webpack_require__.e/* require.ensure */(37).then((function () {
        return r(__webpack_require__(332));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExpressionAbility = function ExpressionAbility(r) {
    return __webpack_require__.e/* require.ensure */(61).then((function () {
        return r(__webpack_require__(253));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Mengmeng = function Mengmeng(r) {
    return __webpack_require__.e/* require.ensure */(60).then((function () {
        return r(__webpack_require__(257));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Sidamingzhu = function Sidamingzhu(r) {
    return __webpack_require__.e/* require.ensure */(58).then((function () {
        return r(__webpack_require__(260));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UnivDream = function UnivDream(r) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
        return r(__webpack_require__(261));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UnivDreamShare = function UnivDreamShare(r) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
        return r(__webpack_require__(262));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//二维码页面
var logicerweima = function logicerweima(r) {
    return __webpack_require__.e/* require.ensure */(94).then((function () {
        return r(__webpack_require__(333));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//21天训练营-我的
var My = function My(r) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
        return r(__webpack_require__(275));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserPoint = function UserPoint(r) {
    return __webpack_require__.e/* require.ensure */(47).then((function () {
        return r(__webpack_require__(276));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserSuggest = function UserSuggest(r) {
    return __webpack_require__.e/* require.ensure */(83).then((function () {
        return r(__webpack_require__(277));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TFUserInfo = function TFUserInfo(r) {
    return __webpack_require__.e/* require.ensure */(48).then((function () {
        return r(__webpack_require__(278));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TFUserName = function TFUserName(r) {
    return __webpack_require__.e/* require.ensure */(85).then((function () {
        return r(__webpack_require__(279));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 21天训练营-老师点评
var Remark = function Remark(r) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
        return r(__webpack_require__(269));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UnRemark = function UnRemark(r) {
    return __webpack_require__.e/* require.ensure */(46).then((function () {
        return r(__webpack_require__(270));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 21天积分商城
var DaysMall = function DaysMall(r) {
    return __webpack_require__.e/* require.ensure */(29).then((function () {
        return r(__webpack_require__(268));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//21天预览
var ExpressionPrev = function ExpressionPrev(r) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
        return r(__webpack_require__(282));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var LowerPrev = function LowerPrev(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__(283));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CenterPrev = function CenterPrev(r) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
        return r(__webpack_require__(344));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 小程序h5辅助展示，分享朋友圈
var Miniapp = function Miniapp(r) {
    return __webpack_require__.e/* require.ensure */(96).then((function () {
        return r(__webpack_require__(315));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Trainapp = function Trainapp(r) {
    return __webpack_require__.e/* require.ensure */(69).then((function () {
        return r(__webpack_require__(343));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// h5 demo
var Demo = function Demo(r) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
        return r(__webpack_require__(311));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PinYin = function PinYin(r) {
    return __webpack_require__.e/* require.ensure */(91).then((function () {
        return r(__webpack_require__(267));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 七大能力
var AbilityIntro = function AbilityIntro(r) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
        return r(__webpack_require__(286));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AbilityGames = function AbilityGames(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__(284));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TestSheep = function TestSheep(r) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
        return r(__webpack_require__(237));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AbilityResult = function AbilityResult(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(285));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 新年活动
var HappyNewYear2018 = function HappyNewYear2018(r) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
        return r(__webpack_require__(254));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var HappyNewYear2018Share = function HappyNewYear2018Share(r) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
        return r(__webpack_require__(255));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var NewYear2018Gift = function NewYear2018Gift(r) {
    return __webpack_require__.e/* require.ensure */(59).then((function () {
        return r(__webpack_require__(258));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history', // 删除url中的#
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_3__App___default.a
    },
    //PC端二维码
    {
        path: '/docqrcode',
        component: DocQrCode,
        meta: {
            title: '文件二维码'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            document.title = to.meta.title;
            next();
        }
    },
    // 用户中心-首页
    {
        path: '/user',
        component: UserCenter,
        children: [
        // 中心
        {
            path: 'home',
            component: UserHome,
            meta: {
                title: '我的中心'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 手机号登录
        {
            path: 'phonelogin',
            component: UserPhoneLogin,
            meta: {
                title: '手机号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 作业答案
        {
            path: 'answer',
            component: Answer,
            meta: {
                title: '巩固答案'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 完善信息
        {
            path: 'compinfo',
            component: CompleteInfo,
            meta: {
                title: '完善信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 学而思账号登录
        {
            path: 'xeslogin',
            component: UserXesLogin,
            meta: {
                title: '学而思账号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 表单
        {
            path: 'info',
            component: UserInfo,
            meta: {
                title: '个人信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //性别
        {
            path: 'sex',
            component: UserSex,
            meta: {
                title: '选择性别'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 切换手机
        {
            path: 'switchphone',
            component: UserSwitchPhone,
            meta: {
                title: '切换手机号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 绑定手机
        {
            path: 'bindphone',
            component: UserBindPhone,
            meta: {
                title: '绑定手机号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //邮箱
        {
            path: 'mail',
            component: UserMail,
            meta: {
                title: '填写邮箱'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //切换学员编号
        {
            path: 'stunum',
            component: SwitchStuNum,
            meta: {
                title: '切换学员编号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //我的资料下载
        {
            path: 'document',
            component: UserDocument,
            meta: {
                title: '我的资料'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //素材管理
        {
            path: 'material',
            component: UserDownload,
            meta: {
                title: '资料下载'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //下载选择
        {
            path: 'select',
            component: DownloadSelect,
            meta: {
                title: '文件详情'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examcard',
            component: ExamCard,
            meta: {
                title: '准考证'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examinfo',
            component: ExamInfo,
            meta: {
                title: '考场信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
            beforeLeave: function beforeLeave(to, from, next) {
                console.log(to);
                console.log(form);
                next();
            }
        }, {
            path: 'examNotice',
            component: ExamNotice,
            meta: {
                title: '考场信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examquery',
            component: ExamQuery,
            meta: {
                title: '考场列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                if (from.fullPath.indexOf('classLIst') > -1) {
                    window.location.href = '/user/examquery';
                } else {
                    next();
                }
            }
        }, {
            path: 'scheduleQuery',
            component: ScheduleQuery,
            meta: {
                title: '课表查询'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'classList',
            component: ClassList,
            meta: {
                title: '课次列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                console.log(from);
                if (from.fullPath.indexOf('gotoWhere=1') > -1) {
                    // this.$router.go('/user/examquery')
                    window.location.href = '/user/examquery';
                } else {
                    next();
                }
                next();
            }
        }, {
            path: 'testlist',
            component: TestList,
            meta: {
                title: '考试列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'ifsreport',
            component: IfsReport,
            meta: {
                title: 'IFS成绩报告'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'follow',
            component: Follow,
            meta: {
                title: '关注公众号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    },
    // 本地图文
    {
        path: '/pictext',
        component: Imagetext,
        children: [{
            path: 'wximgtext',
            component: Wximagetext
        }, {
            path: 'pcimgtext',
            component: Pcimagetext
        }]
    },
    // wxh5 活动
    {
        path: '/huodong',
        component: Huodong,
        children: [
        // 活动-手机号登录
        {
            path: 'phonelogin',
            component: ActPhoneLogin,
            meta: {
                title: '手机号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 活动-学而思账号登录
        {
            path: 'xeslogin',
            component: ActXesLogin,
            meta: {
                title: '学而思账号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 活动-绑定手机号
        {
            path: 'bindphone',
            component: ActBindPhone,
            meta: {
                title: '绑定手机号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 活动-完善信息页
        {
            path: 'compinfo',
            component: ActCompInfo,
            meta: {
                title: '报名信息完善'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //活动页面-选择场次
        {
            path: 'selectspace',
            component: SelectSpace,
            meta: {
                title: '报名'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //活动页面-内容
        {
            path: 'content',
            component: Content,
            meta: {
                title: '活动报名'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    },
    // 21天
    {
        path: '/habit',
        component: Habit,
        children: [{
            path: 'introduce',
            component: Introduce,
            meta: {
                title: '21天表达训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'more',
            component: IntroduceMore,
            meta: {
                title: '21天表达训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'center',
            component: Center,
            meta: {
                title: '21天表达训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },

            children: [{
                path: 'expression',
                component: Expression,
                meta: {
                    title: '21天表达训练营'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        // 未登录，去活动介绍页面
                        location.href = '/habit/introduce';
                    } else {
                        next();
                    }
                }
            }, {
                path: 'card',
                component: Card,
                meta: {
                    title: '我的打卡'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        // 未登录，去活动介绍页面
                        location.href = '/habit/introduce';
                    } else {
                        next();
                    }
                }
            }, {
                path: 'journal',
                component: Journal,
                meta: {
                    title: '成长日记'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        // 未登录，去活动介绍页面
                        location.href = '/habit/introduce';
                    } else {
                        next();
                    }
                }
            }, {
                path: 'my',
                component: My,
                meta: {
                    title: '个人中心'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        // 未登录，去活动介绍页面
                        location.href = '/habit/introduce';
                    } else {
                        next();
                    }
                }
            }]
        }, {
            path: 'lower',
            component: Lower,
            meta: {
                title: '看绘本听音频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'higher',
            component: Higher,
            meta: {
                title: '看视频，录观点'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, { // 答题记录
            path: 'result',
            component: ExamsResult,
            meta: {
                title: '答题记录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'tfuserinfo',
            component: TFUserInfo,
            meta: {
                title: '我的信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'tfusername',
            component: TFUserName,
            meta: {
                title: '编辑姓名'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'point',
            component: UserPoint,
            meta: {
                title: '我的积分'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'suggest',
            component: UserSuggest,
            meta: {
                title: '意见反馈'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/habit/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'share',
            component: CardShare,
            meta: {
                title: '分享成就'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 表达指导
        {
            path: 'guide',
            component: GuideIllustration,
            meta: {
                title: '21天表达秘籍'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 表达指导
        {
            path: 'sleep',
            component: Sleep,
            meta: {
                title: '恭喜您获得睡前故事'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'chengyu',
            component: ChengYu,
            meta: {
                title: '恭喜您获得成语故事'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'kaidike',
            component: KaiDiKe,
            meta: {
                title: '恭喜您获得凯迪克大奖绘本'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'gushi',
            component: GuShi,
            meta: {
                title: '恭喜您获得小学必背古诗'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'ciyu',
            component: CiYu,
            meta: {
                title: '恭喜您获得小学必备词语句式'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 老师评价页面
        {
            path: 'remark',
            component: Remark,
            meta: {
                title: '点评订单'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 老师未评价列表
        {
            path: 'unremark',
            component: UnRemark,
            meta: {
                title: '未点评订单'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 21天积分商城
        {
            path: 'mall',
            component: DaysMall,
            meta: {
                title: '积分商城'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'video',
            component: Video,
            meta: {
                title: '学而思学前第一届故事大赛'
            },
            query: {
                id: 0
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'videoupload',
            component: videoUpload,
            query: {
                status: 1,
                videoUrl: ''
            },
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lecturer',
            component: Lecturer,
            meta: {
                title: '学而思萌娃小讲师活动'
            },
            query: {
                id: 0
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lecshare',
            component: lectureShare,
            meta: {
                title: '学而思萌娃小讲师活动'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'schedule',
            component: lectureTime,
            meta: {
                title: '时间安排'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'subjects',
            component: lectureSubjects,
            meta: {
                title: '萌娃题库'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lecturerupload',
            component: LecturerList,
            query: {
                status: 1,
                videoUrl: ''
            },
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'uploadvideo',
            component: lectureSubjects,
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lecturersh',
            component: Lecturersh,
            meta: {
                title: '学而思萌娃小讲师活动'
            },
            query: {
                id: 0
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lecsharesh',
            component: lectureSharesh,
            meta: {
                title: '学而思萌娃小讲师活动'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'schedulesh',
            component: lectureTimesh,
            meta: {
                title: '时间安排'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'subjectssh',
            component: lectureSubjectssh,
            meta: {
                title: '萌娃题库'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'lectureruploadsh',
            component: LecturerListsh,
            query: {
                status: 1,
                videoUrl: ''
            },
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'uploadvideosh',
            component: lectureSubjectssh,
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'guangzhou',
            component: Guangzhou,
            meta: {
                title: '广州表达之星'
            },
            query: {
                id: 0
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'guangzhouupload',
            component: GuangzhouList,
            query: {
                status: 1,
                videoUrl: ''
            },
            meta: {
                title: '提交视频'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                // document.title = to.meta.title;
                next();
            }
        }, {
            path: 'aftershare',
            component: afterShare,
            query: {
                shs_user_id: ''
            },
            meta: {
                title: '广州表达之星'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'christmas',
            component: Christmas,
            meta: {
                title: '定制你的圣诞祝福'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'chrisshare',
            component: ChristmasShare,
            meta: {
                title: '定制你的圣诞祝福'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'kaidikebook',
            component: kaidikeBook,
            meta: {
                title: '凯迪克大奖绘本'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'mengmeng',
            component: Mengmeng,
            meta: {
                title: '成语微课资料包'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'sidamingzhu',
            component: Sidamingzhu,
            meta: {
                title: '四大名著全面解析资料包'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'expressionability',
            component: ExpressionAbility,
            meta: {
                title: '表达能力微课'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'prize',
            component: Prize,
            meta: {
                title: '21天训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'prizeshare',
            component: PrizeShare,
            meta: {
                title: '21天训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'logicerweima',
            component: logicerweima,
            meta: {
                title: '21天训练营pro'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'zhuli',
            component: zhuli,
            meta: {
                title: '21天训练营礼物中心'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },

            children: [
            // 助力活动
            {
                path: 'list',
                component: list,
                meta: {
                    title: '21天训练营礼物中心'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    next();
                }
            },
            // 详情页
            {
                path: 'detail',
                component: Detail,
                meta: {
                    title: '21天训练营礼品中心'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        //     // 未登录，去首页
                        location.href = '/habit/zhuli/list';
                    } else {
                        next();
                    }
                }
            },
            // 地址页面
            {
                path: 'address',
                component: Address,
                meta: {
                    title: '21天训练营'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                    if (!phone) {
                        //     // 未登录，去首页
                        location.href = '/habit/zhuli/list';
                    } else {
                        next();
                    }
                }
            }, {
                path: 'share',
                component: Share,
                meta: {
                    title: '21天训练营'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    next();
                }
            }, {
                path: 'exchangeprize',
                component: ExchangePrize,
                meta: {
                    title: '21天训练营礼物中心'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    next();
                }
            }]
        },
        // 新年换装
        {
            path: 'happy2018',
            component: HappyNewYear2018,
            meta: {
                title: '定制你的新年祝福'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'newyearshare',
            component: HappyNewYear2018Share,
            meta: {
                title: '定制你的新年祝福'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'newyeargift',
            component: NewYear2018Gift,
            meta: {
                title: '定制你的新年祝福'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'univdreamshare',
            component: UnivDreamShare,
            meta: {
                title: '我有一个大学梦'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'univdream',
            component: UnivDream,
            meta: {
                title: '我有一个大学梦'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    },

    //21天preview
    {
        path: '/preview',
        component: Habit,
        children: [{
            path: 'center',
            component: CenterPrev,
            meta: {
                title: '21天表达训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },

            children: [{
                path: 'exprssionprev',
                component: ExpressionPrev,
                query: { classId: 123 },
                meta: {
                    title: '21天表达训练营-预览'
                },
                beforeEnter: function beforeEnter(to, from, next) {
                    document.title = to.meta.title;
                    next();
                }
            }]
        }, {
            path: 'lowerprev',
            component: LowerPrev,
            meta: {
                title: '看绘本听音频-预览'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    },
    //7大能力
    {
        path: '/sevenability',
        component: Habit,
        children: [{
            path: 'introduce',
            component: AbilityIntro,
            meta: {
                title: '幼儿思维能力评估'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'game',
            component: AbilityGames,
            meta: {
                title: '幼儿思维能力评估'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
                var phone = __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__["a" /* default */].get('cGlk');
                if (!phone) {
                    // 未登录，去活动介绍页面
                    location.href = '/sevenability/introduce';
                } else {
                    next();
                }
            }
        }, {
            path: 'report',
            component: AbilityResult,
            meta: {
                title: '幼儿思维能力评估'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    }, {
        path: '/miniapp',
        component: Miniapp,
        children: [{
            path: 'train',
            component: Trainapp,
            meta: {
                title: '训练营'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    },
    // demo
    {
        path: '/demo',
        component: Demo,
        meta: {
            wxshare: 1,
            title: 'h5 demo'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            document.title = to.meta.title;
            next();
        }
    },
    // 拼音检查
    {
        path: '/pinyin',
        component: PinYin,
        meta: {
            title: '拼音检查'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            document.title = to.meta.title;
            next();
        }
    }, {
        path: '/:userCenterId',
        component: UserHome
    }]
}));

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_baseUrl__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_wxAuth__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_userInfo__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_provincialGrade__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_habitUserInfo__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_habitJournal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_habitCard__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_audioStatus__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_lRecordModel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_hRecordModel__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_lAnswerModel__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_mAnswerModel__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_mRecordModel__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_habitLower__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_habitUserInfoPrev__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_habitCardPrev__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_sevenAbilityPlayer__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_sevenAbilityGames__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_sevenAbilityIntroduce__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_happyNewYear2018__ = __webpack_require__(176);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
















// 七大能力



// 新年换装2018

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        baseUrl: __WEBPACK_IMPORTED_MODULE_2__modules_baseUrl__["a" /* default */],
        wxAuth: __WEBPACK_IMPORTED_MODULE_3__modules_wxAuth__["a" /* default */],
        userInfo: __WEBPACK_IMPORTED_MODULE_4__modules_userInfo__["a" /* default */],
        provincialGrade: __WEBPACK_IMPORTED_MODULE_5__modules_provincialGrade__["a" /* default */],
        // 21天
        habitUserInfo: __WEBPACK_IMPORTED_MODULE_6__modules_habitUserInfo__["a" /* default */],
        habitJournal: __WEBPACK_IMPORTED_MODULE_7__modules_habitJournal__["a" /* default */],
        habitCard: __WEBPACK_IMPORTED_MODULE_8__modules_habitCard__["a" /* default */],
        audioStatus: __WEBPACK_IMPORTED_MODULE_9__modules_audioStatus__["a" /* default */], // audio 播放状态总线
        lRecordModel: __WEBPACK_IMPORTED_MODULE_10__modules_lRecordModel__["a" /* default */], // low-l1-3-model
        lAnswerModel: __WEBPACK_IMPORTED_MODULE_12__modules_lAnswerModel__["a" /* default */], //low-l1-3-answer-model
        mAnswerModel: __WEBPACK_IMPORTED_MODULE_13__modules_mAnswerModel__["a" /* default */], // mid L4-6
        mRecordModel: __WEBPACK_IMPORTED_MODULE_14__modules_mRecordModel__["a" /* default */], // mid L4-6
        habitLower: __WEBPACK_IMPORTED_MODULE_15__modules_habitLower__["a" /* default */], //low-l1-3
        hRecordModel: __WEBPACK_IMPORTED_MODULE_11__modules_hRecordModel__["a" /* default */], //higher-l7-9-model
        //21天预览
        habitUserInfoPrev: __WEBPACK_IMPORTED_MODULE_16__modules_habitUserInfoPrev__["a" /* default */],
        habitCardPrev: __WEBPACK_IMPORTED_MODULE_17__modules_habitCardPrev__["a" /* default */],
        // 七大能力
        sevenAbilityPlayer: __WEBPACK_IMPORTED_MODULE_18__modules_sevenAbilityPlayer__["a" /* default */],
        sevenAbilityGames: __WEBPACK_IMPORTED_MODULE_19__modules_sevenAbilityGames__["a" /* default */],
        sevenAbilityIntroduce: __WEBPACK_IMPORTED_MODULE_20__modules_sevenAbilityIntroduce__["a" /* default */],
        // 新年换装2018
        happyNewYear2018: __WEBPACK_IMPORTED_MODULE_21__modules_happyNewYear2018__["a" /* default */]
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    created: function created() {
        var baseUrl = this.$store.state.baseUrl.url;
        if (baseUrl) {
            // 已经赋值
        } else {
            // 需要赋值
            var url = location.href;
            this.$store.dispatch('setBaseUrl', url);
        }
    }
});

/***/ }),
/* 136 */
/***/ (function(module, exports) {

//
//
//

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__vuex_store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_event_calendar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_event_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vue_event_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__common_util_network_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__common_util_global__ = __webpack_require__(5);






































__webpack_require__(61).polyfill();




__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default.a.name, __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default.a.name, __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default.a.name, __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a.name, __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default.a.name, __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default.a.name, __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default.a.name, __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default.a.name, __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default.a.name, __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a.name, __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default.a.name, __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default.a);




// import 'vue-event-calendar/dist/style.css';

__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_44_vue_event_calendar___default.a, { locale: 'zh', color: '#fd8b23' });
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$messageBox = __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$indicator = __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_39_axios___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].config.productionTip = false;
// net listener

__WEBPACK_IMPORTED_MODULE_46__common_util_network_js__["a" /* offLineLister */]();

var dateFilter = function dateFilter(value, fmt) {
    if (value) {
        var date = new Date(value * 1000);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return fmt;
    } else {
        return '   -';
    }
};


__WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_47__common_util_global__["a" /* isAndroid */]) {
        // android 需要每次都赋予当前的值
        __WEBPACK_IMPORTED_MODULE_43__vuex_store__["a" /* default */].state.baseUrl.url = location.origin + to.fullPath;
    }
    next();
});

__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$dateFilter = dateFilter;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].filter('dateFilter', dateFilter);

new __WEBPACK_IMPORTED_MODULE_38_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_43__vuex_store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_41__App___default.a }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setLexamStatus: function setLexamStatus(context, data) {
        context.commit('setLexamStatus', data);
    },
    setMexamStatus: function setMexamStatus(context, data) {
        context.commit('setMexamStatus', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(40);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(141);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setLexamStatus: function setLexamStatus(state, data) {
        // 变更L1-3低级问答播放audio播放状态
        state.lexam_status = data;
    },
    setMexamStatus: function setMexamStatus(state, data) {
        // 变更L1-3低级问答播放audio播放状态
        state.mexam_status = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setBaseUrl: function setBaseUrl(context, data) {
        context.commit('setBaseUrl', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(41);

var getters = {
    getBaseUrl: function getBaseUrl(state) {
        return state.url;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(145);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setBaseUrl: function setBaseUrl(state, data) {
        // 变更base url
        state.url = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setHRecordModel: function setHRecordModel(context, data) {
        context.commit('setHRecordModel', data);
    },
    clearHRecord: function clearHRecord(context, data) {
        context.commit('clearHRecord');
    },
    setAllHRecordModel: function setAllHRecordModel(context, data) {
        context.commit('setAllHRecordModel', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(42);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(149);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setHRecordModel: function setHRecordModel(state, data) {
        // 变更low-level-model
        var index = data.index;
        var recordModel = data.recordModel;
        state.recordModel[index - 1] = recordModel;
        // state.recordModel.push(recordModel);
    },
    clearHRecord: function clearHRecord(state) {
        state.recordModel = [];
    },
    setAllHRecordModel: function setAllHRecordModel(state, data) {
        // 变更low-level-model
        state.recordModel = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    cardInfo: '/i/day21/api/training',
    cardSign: '/i/day21/api/sign'
};

var actions = {
    getDays21CardInfo: function getDays21CardInfo(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.cardInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('days21CardInit', data.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取课程信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            console.log(error);
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21CardSave: function days21CardSave(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.cardSign,
            'params': dataObj,
            'method': 'post'
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21CardUpdate', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21CardUpdate: function days21CardUpdate(context, dataObj) {
        context.commit('days21CardUpdate', dataObj);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(43);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(153);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_global__ = __webpack_require__(5);

var mutations = {
    days21CardInit: function days21CardInit(state, data) {
        // l1-l3为数组
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_util_global__["c" /* isArray */])(data.story.story)) {
            data.story.story.sort(function (a, b) {
                return a.pn - b.pn;
            });
            data.question.sort(function (a, b) {
                return a.pn - b.pn;
            });
            state.question = data.question;
            state.question_pages = data.question.length;
            state.storys = data.story.story;
            state.storys_pages = data.story.story.length;
            state.total_pages = data.question.length + (data.story.story.length - 1) * 2;
            state.total_days = (Number(data.training.period_id) - 1) * 21 + Number(data.training.day_id);
            state.cover_img = data.story.story[0].img;
            state.cover_title = data.story.story[0].title;
            state.cover_text = data.story.story[0].text;
            state.cover_audio = data.story.story[0].audio;
        } else {
            // state.higher = {
            //     course_video: {
            //         size: "1024",
            //         url: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1515380639572_030008010059C3809596D7131CB684565A498F-CDE9-3713-D57A-9D322669CE39.mp4"
            //     },
            //     template_video: {
            //         size: "1024",
            //         url: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1515380639572_030008010059C3809596D7131CB684565A498F-CDE9-3713-D57A-9D322669CE39.mp4"
            //     },
            //     core_words: [
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"最后一个词",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         }
            //         ],
            //     title:"第七天",
            // };
            state.higher = data.story.story;
            state.cover_title = data.story.story.title;
            state.cover_text = data.story.text;
            state.cover_audio = data.story.audio;
        }

        //l1-l3 与 l7-l9公共数据
        state.user_audio = data.training && data.training.user_audio; //l7-l9 新加
        state.user_weixin_audio = data.training && data.training.user_weixin_audio;
        state.status = data.status;
        state.share_id = data.training ? data.training.id : '';

        // state.question = [{
        //     answer: {
        //         A: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810198096_%25E9%25BB%2598%25E8%25AE%25A4%25E6%25A0%2587%25E9%25A2%2598_%25E5%2585%25AC%25E4%25BC%2597%25E5%258F%25B7%25E5%25B0%2581%25E9%259D%25A2%25E5%25B0%258F%25E5%259B%25BE_2017.12.09.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810272241_L1-7-%25E6%25A0%2587%25E9%25A2%2598.mp3", 
        //             text: "坐、爬"
        //         },
        //         B: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810991030_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810979989_L1-7-%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.mp3", 
        //             text: "坐、捉"
        //         },
        //         C: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811148650_1.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811027187_7%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.mp3", 
        //             text: "做、捉"
        //         }
        //     },
        //     ask: {
        //         audio:"http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810485821_L1-5-%25E9%2597%25AE%25E7%25AD%2594.mp3",
        //         img: "",
        //         // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811018497_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.jpg",
        //         text: "今天学了哪两个动词？"
        //     },
        //     std_answer: "B",
        // },
        // {
        //     answer: {
        //         A: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810198096_%25E9%25BB%2598%25E8%25AE%25A4%25E6%25A0%2587%25E9%25A2%2598_%25E5%2585%25AC%25E4%25BC%2597%25E5%258F%25B7%25E5%25B0%2581%25E9%259D%25A2%25E5%25B0%258F%25E5%259B%25BE_2017.12.09.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810272241_L1-7-%25E6%25A0%2587%25E9%25A2%2598.mp3", 
        //             text: "坐、爬"
        //         },
        //         B: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810991030_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810979989_L1-7-%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.mp3", 
        //             text: "坐、捉"
        //         },
        //         C: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811148650_1.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811027187_7%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.mp3", 
        //             text: "做、捉"
        //         }
        //     },
        //     ask: {
        //         audio:"http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810485821_L1-5-%25E9%2597%25AE%25E7%25AD%2594.mp3",
        //         img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811018497_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.jpg",
        //         text: "今天学了哪两个动词？"
        //     },
        //     std_answer: "C",
        // }
        // ];

        state.demo_audio = data.training.demo_audio;
        state.period_id = Number(data.period_id);
        state.day_id = Number(data.day_id);
        state.series_day = Number(data.training.series_day);
        state.during = Number(data.training.during);
        state.loves = data.loves;
        // 标记数据已经初始化
        state.inited = true;
    },
    days21CardUpdate: function days21CardUpdate(state, data) {
        state.share_id = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    cardInfo: '/i/day21/api/gettraining',
    cardSign: '/i/day21/api/sign'
};

var actions = {
    getDays21CardInfoPrev: function getDays21CardInfoPrev(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.cardInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            // debugger
            var data = result.data ? result.data : {};
            // data 判断
            // alert(data);
            if (data.error_code == 0) {
                context.commit('days21CardInitPrev', data.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取课程信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            // debugger
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试啊啊啊~');
        });
    },
    days21CardSavePrev: function days21CardSavePrev(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.cardSign,
            'params': dataObj,
            'method': 'post'
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21CardUpdatePrev', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21CardUpdatePrev: function days21CardUpdatePrev(context, dataObj) {
        context.commit('days21CardUpdatePrev', dataObj);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(44);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(157);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_global__ = __webpack_require__(5);

var mutations = {
    days21CardInitPrev: function days21CardInitPrev(state, data) {
        data.story.story.sort(function (a, b) {
            return a.pn - b.pn;
        });
        data.question.sort(function (a, b) {
            return a.pn - b.pn;
        });
        state.question = data.question;
        state.question_pages = data.question.length;
        state.storys = data.story.story;
        state.storys_pages = data.story.story.length;
        state.total_pages = data.question.length + (data.story.story.length - 1) * 2;
        // state.demo_audio = data.training.demo_audio;
        state.period_id = Number(data.period_id);
        state.day_id = Number(data.day_id);
        // state.total_days = (Number(data.training.period_id) - 1) * 21 + Number(data.training.day_id);
        // state.series_day = Number(data.training.series_day);
        // state.during = Number(data.training.during);
        state.cover_img = data.story.story[0].img;
        state.cover_title = data.story.story[0].title;
        state.cover_text = data.story.story[0].text;
        state.cover_audio = data.story.story[0].audio;
        // state.user_weixin_audio = data.training.user_weixin_audio;
        // state.loves = data.loves;
        //标记数据已经初始化
        state.inited = true;
    },
    days21CardUpdatePrev: function days21CardUpdatePrev(state, data) {
        state.share_id = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    getCommentsNum: '/i/day21/api/getredpoint'
};

var actions = {
    getCommentNumAction: function getCommentNumAction(context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            url: urls.getCommentsNum,
            params: {
                scene: '1'
            }
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('habitCommentNum', data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    updateCommentAction: function updateCommentAction(context, data) {
        context.commit('updateCommentMutation', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(45);

var getters = {
    getCommentDate: function getCommentDate(state) {
        return state.commentDate;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(161);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_global__ = __webpack_require__(5);

var mutations = {
    habitCommentNum: function habitCommentNum(state, data) {
        state.commentDate = data.data; // 有老师评价的日期
    },
    updateCommentMutation: function updateCommentMutation(state, data) {
        state.commentDate = data; // 更新老师数组
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setIsShowGenduPopup: function setIsShowGenduPopup(context, data) {
        context.commit('setIsShowGenduPopup', data);
    },
    setIsShowWendaPopup: function setIsShowWendaPopup(context, data) {
        context.commit('setIsShowWendaPopup', data);
    },
    setLastShow: function setLastShow(context, data) {
        context.commit('setLastShow', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(46);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(165);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setIsShowGenduPopup: function setIsShowGenduPopup(state, data) {
        state.isShowGendu = data;
    },
    setIsShowWendaPopup: function setIsShowWendaPopup(state, data) {
        state.isShowWenda = data;
    },

    setLastShow: function setLastShow(state, data) {
        state.lastShow = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    getUserInfo: '/i/day21/api/getuserinfo',
    regUser: '',
    updateUser: '/i/day21/api/updateuserinfo'
};

var actions = {
    getDays21UserInfo: function getDays21UserInfo(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.getUserInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('days21UserInit', data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserReg: function days21UserReg(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.regUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '操作成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21UserReg', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '用户注册失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserSave: function days21UserSave(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.updateUser,
            'params': dataObj,
            'method': 'post'
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21UserUpdate', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserUpdate: function days21UserUpdate(context, dataObj) {
        context.commit('days21UserUpdate', dataObj);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(47);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(169);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_global__ = __webpack_require__(5);

var mutations = {
    days21UserInit: function days21UserInit(state, data) {
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
            state.on_training = data.on_training;
        } else {
            // 不是新用户
            state.is_new = false;
            state.user_state = data.state;
            state.on_training = data.on_training;
            state.icon = data.data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_util_global__["b" /* cutHeadImg */])({
                url: data.data.icon
            }) : '';
            state.nickname = data.data ? data.data.nickname : '';
            state.birthday = data.data ? data.data.birthday : '';
            state.province_id = data.data ? data.data.province_id : '';
            state.province = data.data ? data.data.province : '';
            state.city = data.data ? data.data.city : '';
            state.city_id = data.data ? data.data.city_id : '';
            // 计算age
            // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
            var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
            state.age = Math.floor(agetemp);
            state.remind_time = data.data ? data.data.remind_time : '';
            state.point = data.data ? data.data.point : '';
            state.uid = data.data ? data.data.uid : '';
            state.complete = data.data ? data.data.complete : '';
            //标记数据已经初始化
            state.inited = true;
        }
    },
    days21UserReg: function days21UserReg(state, data) {
        state.icon = data.icon;
        state.nickname = data.nickname;
        state.birthday = data.birthday;
        // 计算age
        // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);
        state.remind_time = data.remind_time;
        state.point = data.point;
    },
    days21UserUpdate: function days21UserUpdate(state, data) {
        state.nickname = data.hasOwnProperty('nickname') ? data.nickname : state.nickname;
        state.icon = data.hasOwnProperty('icon') ? data.icon : state.icon;
        state.inited = data.hasOwnProperty('inited') ? data.inited : state.inited;
        state.birthday = data.hasOwnProperty('birthday') ? data.birthday : state.birthday;
        // state.age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);

        state.remind_time = data.hasOwnProperty('remind_time') ? data.remind_time : state.remind_time;
        state.point = data.hasOwnProperty('point') ? data.point : state.point;
        state.city = data.hasOwnProperty('city') ? data.city : state.city;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province = data.hasOwnProperty('province') ? data.province : state.province;
        state.complete = data.hasOwnProperty('complete') ? data.complete : '';
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    getUserInfo: '/i/day21/api/getuserinfo',
    regUser: '',
    updateUser: '/i/day21/api/updateuserinfo'
};

var actions = {
    getDays21UserInfoPrev: function getDays21UserInfoPrev(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.getUserInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('days21UserInitPrev', data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserRegPrev: function days21UserRegPrev(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.regUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '操作成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21UserRegPrev', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '用户注册失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserSavePrev: function days21UserSavePrev(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.updateUser,
            'params': dataObj,
            'method': 'post'
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21UserUpdatePrev', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    days21UserUpdatePrev: function days21UserUpdatePrev(context, dataObj) {
        context.commit('days21UserUpdatePrev', dataObj);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(48);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(173);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util_global__ = __webpack_require__(5);

var mutations = {
    days21UserInitPrev: function days21UserInitPrev(state, data) {
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
            state.on_training = data.on_training;
        } else {
            // 不是新用户
            state.is_new = false;
            state.user_state = data.state;
            state.on_training = data.on_training;
            state.icon = data.data ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_util_global__["b" /* cutHeadImg */])({
                url: data.data.icon
            }) : '';
            state.nickname = data.data ? data.data.nickname : '';
            state.birthday = data.data ? data.data.birthday : '';
            state.province_id = data.data ? data.data.province_id : '';
            state.province = data.data ? data.data.province : '';
            state.city = data.data ? data.data.city : '';
            state.city_id = data.data ? data.data.city_id : '';
            // 计算age
            // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
            var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
            state.age = Math.floor(agetemp);
            state.remind_time = data.data ? data.data.remind_time : '';
            state.point = data.data ? data.data.point : '';
            state.uid = data.data ? data.data.uid : '';
            state.complete = data.data ? data.data.complete : '';
            //标记数据已经初始化
            state.inited = true;
        }
    },
    days21UserRegPrev: function days21UserRegPrev(state, data) {
        state.icon = data.icon;
        state.nickname = data.nickname;
        state.birthday = data.birthday;
        // 计算age
        // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);
        state.remind_time = data.remind_time;
        state.point = data.point;
    },
    days21UserUpdatePrev: function days21UserUpdatePrev(state, data) {
        state.nickname = data.hasOwnProperty('nickname') ? data.nickname : state.nickname;
        state.icon = data.hasOwnProperty('icon') ? data.icon : state.icon;
        state.inited = data.hasOwnProperty('inited') ? data.inited : state.inited;
        state.birthday = data.hasOwnProperty('birthday') ? data.birthday : state.birthday;
        // state.age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        var agetemp = (new Date().getTime() / 1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);

        state.remind_time = data.hasOwnProperty('remind_time') ? data.remind_time : state.remind_time;
        state.point = data.hasOwnProperty('point') ? data.point : state.point;
        state.city = data.hasOwnProperty('city') ? data.city : state.city;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province = data.hasOwnProperty('province') ? data.province : state.province;
        state.complete = data.hasOwnProperty('complete') ? data.complete : '';
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setHappynewyear2018: function setHappynewyear2018(context, data) {
        context.commit('setHappynewyear2018', data);
    },
    setNewyear2018Bless: function setNewyear2018Bless(context, data) {
        context.commit('setNewyear2018Bless', data);
    },
    setNewyear2018MergeImg: function setNewyear2018MergeImg(context, data) {
        context.commit('setNewyear2018MergeImg', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(49);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(177);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setHappynewyear2018: function setHappynewyear2018(state, data) {
        state.uploadimg = data;
    },
    setNewyear2018Bless: function setNewyear2018Bless(state, data) {
        state.bless = data;
    },
    setNewyear2018MergeImg: function setNewyear2018MergeImg(state, data) {
        state.mergeimg = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setAllAnswer: function setAllAnswer(context, data) {
        context.commit('setAllAnswer', data);
    },
    setlAnswerModel: function setlAnswerModel(context, data) {
        context.commit('setlAnswerModel', data);
    },
    clearLAnswer: function clearLAnswer(context, data) {
        context.commit('clearLAnswer');
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(50);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(181);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setAllAnswer: function setAllAnswer(state, data) {
        state.lAnswers = data;
    },
    setlAnswerModel: function setlAnswerModel(state, data) {
        var index = data.index;
        state.lAnswers[index] = data;
    },
    clearLAnswer: function clearLAnswer(state) {
        state.lAnswers = [];
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setRecordModel: function setRecordModel(context, data) {
        context.commit('setRecordModel', data);
    },
    clearLRecord: function clearLRecord(context, data) {
        context.commit('clearLRecord');
    },
    setAllRecordModel: function setAllRecordModel(context, data) {
        context.commit('setAllRecordModel', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(51);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(185);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setRecordModel: function setRecordModel(state, data) {
        // 变更low-level-model
        var index = data.index;
        var recordModel = data.recordModel;
        state.recordModel[index - 1] = recordModel;
        // state.recordModel.push(recordModel);
    },
    clearLRecord: function clearLRecord(state) {
        state.recordModel = [];
    },
    setAllRecordModel: function setAllRecordModel(state, data) {
        // 变更low-level-model
        state.recordModel = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setAllAnswer: function setAllAnswer(context, data) {
        context.commit('setAllAnswer', data);
    },
    setmAnswerModel: function setmAnswerModel(context, data) {
        context.commit('setmAnswerModel', data);
    },
    clearMAnswer: function clearMAnswer(context, data) {
        context.commit('clearMAnswer');
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(52);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(189);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setAllAnswer: function setAllAnswer(state, data) {
        state.mAnswers = data;
    },
    setmAnswerModel: function setmAnswerModel(state, data) {
        var index = data.index;
        state.mAnswers[index] = data;
    },
    clearMAnswer: function clearMAnswer(state) {
        state.mAnswers = [];
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setMRecordModel: function setMRecordModel(context, data) {
        context.commit('setMRecordModel', data);
    },
    clearMRecord: function clearMRecord(context, data) {
        context.commit('clearMRecord');
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(53);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(193);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setMRecordModel: function setMRecordModel(state, data) {
        // 变更mid-level-model
        var recordModel = data;
        state.mrecordModel = recordModel;
    },
    clearMRecord: function clearMRecord(state) {
        state.mrecordModel = '';
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    getProvincial: '/i/wechat/api/city',
    getGrade: '/i/wechat/api/grade'
};

var actions = {
    getProvincialInfo: function getProvincialInfo(context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.getProvincial
        }).then(function (res) {
            var result = res.data ? res.data : {};
            // data 判断
            if (result.error_code == 0) {
                context.commit('provinceInfo', result.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(result.error_msg || '省市配置信息获取失败！');
            }
            return result;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    getGradeInfo: function getGradeInfo(context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.getGrade
        }).then(function (res) {
            var result = res.data ? res.data : {};
            if (result.error_code == 0) {
                context.commit('gradeInfo', result.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(result.error_msg || '年级信息获取失败');
            }
            return result;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(54);

var getters = {
    getAllGrade: function getAllGrade(state) {
        return state.grades;
    },
    getProvinces: function getProvinces(state) {
        return state.provinces;
    },
    getProvincesIdMap: function getProvincesIdMap(state) {
        return state.provincesIdMap;
    },
    getCitysIdMap: function getCitysIdMap(state) {
        return state.citysIdMap;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(197);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var mutations = {
    provinceInfo: function provinceInfo(state, data) {
        // 更新信息
        state.provinces = data;
        var cityArrayTemp = [];
        data.map(function (item, index) {
            state.provincesIdMap[item.province_id] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.name);
            // 处理城市
            cityArrayTemp = item.city_list;
            var temp = '';
            cityArrayTemp.map(function (city, index) {
                temp = '' + item.province_id + city.city_id;
                state.citysIdMap[temp] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(city.name);
            });
        });
    },
    gradeInfo: function gradeInfo(state, data) {
        // 更新信息
        state.grades = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setShuerte: function setShuerte(context, data) {
        context.commit('setShuerte', data);
    },
    setSheepGame: function setSheepGame(context, data) {
        context.commit('setSheepGame', data);
    },
    setAttentionGame: function setAttentionGame(context, data) {
        context.commit('setAttentionGame', data);
    },
    setRankGame: function setRankGame(context, data) {
        context.commit('setRankGame', data);
    },
    setRegulaGame: function setRegulaGame(context, data) {
        context.commit('setRegulaGame', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(55);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(201);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setShuerte: function setShuerte(state, data) {
        state.shuerteGame = data;
    },
    setAttentionGame: function setAttentionGame(state, data) {
        state.attentionGame = data;
    },
    setSheepGame: function setSheepGame(state, data) {
        state.findSheepGame = data;
    },
    setRankGame: function setRankGame(state, data) {
        state.rankGame = data;
    },
    setRegulaGame: function setRegulaGame(state, data) {
        state.regulaGame = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setPhone: function setPhone(context, data) {
        context.commit('setPhone', data);
    },
    setHeadImg: function setHeadImg(context, data) {
        context.commit('setHeadImg', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(56);

var getters = {
    getPhone: function getPhone(state) {
        return state.login.phone;
    },
    getHeadImg: function getHeadImg(state) {
        return state.login.headimg;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(205);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setPhone: function setPhone(state, data) {
        state.login.phone = data;
    },
    setHeadImg: function setHeadImg(state, data) {
        state.login.headimg = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setSevenPlayerStatus: function setSevenPlayerStatus(context, data) {
        context.commit('setSevenPlayerStatus', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(57);

var getters = {};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(209);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setSevenPlayerStatus: function setSevenPlayerStatus(state, data) {
        state.senvenPlayer_status = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_request__ = __webpack_require__(4);





var urls = {
    getUserInfo: '/i/wechat/user/getuserinfo',
    // regUser: '/wechat/api/register',
    regUser: '/i/wechat/api/userregister',
    updateUser: '/i/wechat/user/updateuserinfo'
};

var actions = {
    getUserInfo: function getUserInfo(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.getUserInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('userInit', data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    userReg: function userReg(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.regUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '操作成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userReg', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '用户注册失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    userUpdate: function userUpdate(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_request__["a" /* request */])({
            'url': urls.updateUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userUpdate', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    updateUName: function updateUName(context, data) {
        context.commit('updateUName', data);
    },
    updateUserImg: function updateUserImg(context, data) {
        context.commit('updateUserImg', data);
    },
    updateSex: function updateSex(context, data) {
        context.commit('updateSex', data);
    },
    updateProvince: function updateProvince(context, data) {
        context.commit('updateProvince', data);
    },
    updateCity: function updateCity(context, data) {
        context.commit('updateCity', data);
    },
    updateProvinceName: function updateProvinceName(context, data) {
        context.commit('updateProvinceName', data);
    },
    updateCityName: function updateCityName(context, data) {
        context.commit('updateCityName', data);
    },
    updateGrade: function updateGrade(context, data) {
        context.commit('updateGrade', data);
    },
    updatePhone: function updatePhone(context, data) {
        context.commit('updatePhone', data);
    },
    updatePhoneCode: function updatePhoneCode(context, data) {
        context.commit('updatePhoneCode', data);
    },
    updateMail: function updateMail(context, data) {
        context.commit('updateMail', data);
    },
    updateBirth: function updateBirth(context, data) {
        context.commit('updateBirth', data);
    },
    updateAreaCode: function updateAreaCode(context, data) {
        context.commit('updateAreaCode', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(58);

var getters = {
    getUserInfoName: function getUserInfoName(state) {
        return state.name;
    },
    getUserSex: function getUserSex(state) {
        return state.sex;
    },
    getUserGrade: function getUserGrade(state) {
        return state.grade;
    },
    getUserMail: function getUserMail(state) {
        return state.email;
    },
    getUserBirth: function getUserBirth(state) {
        return state.birth;
    },
    getUserStuNum: function getUserStuNum(state) {
        return state.stu_num;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(213);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    userInit: function userInit(state, data) {
        console.log(data, 123);
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
        } else {
            // 不是新用户
            state.is_new = false;
            state.is_complete = data.data.user_info_complete;
            state.user_state = data.state;
            state.headimg = data.data ? data.data.head_pic : '';
            state.name = data.data ? data.data.name : '';
            state.phone = data.data ? data.data.phone : '';
            state.province_id = data.data && data.data.province ? data.data.province.province_id : '';
            var province_name = data.data && data.data.province ? data.data.province.province_name : '';
            state.province_name = province_name ? province_name : '';
            state.city_id = data.data && data.data.city ? data.data.city.city_id : '';
            var city_name = data.data && data.data.city ? data.data.city.city_name : '';
            state.city_name = city_name ? city_name : '';
            state.sex = data.data ? data.data.sex : '';
            state.grade = data.data && data.data.grade ? data.data.grade.grade_code : '';
            state.email = data.data ? data.data.email : '';
            state.uid = data.data ? data.data.uid : '';
            state.stu_num = data.data ? data.data.stu_num : '';
            state.birth = data.birth;
            state.state = data.data.state;
            var area_code = data.data && data.data.city ? data.data.city.area_code : '';
            state.area_code = area_code ? area_code : '';
            var py_area_code = data.data && data.data.py_data ? data.data.py_data.bindingCode : '';
            state.py_area_code = py_area_code ? py_area_code : ''; //培优地区码
            var py_area_name = data.data && data.data.py_data ? data.data.py_data.cityName : '';
            state.py_area_name = py_area_name ? py_area_name : ''; //培优地区名称
            var py_real_name = data.data && data.data.py_data ? data.data.py_data.realname : '';
            state.py_real_name = py_real_name ? py_real_name : ""; //培优真实姓名
            var py_grade = data.data && data.data.py_data ? data.data.py_data.grid : '';
            state.py_grade = py_grade ? py_grade : ''; //培优年级
            var stu_id = data.data ? data.data.stu_id : '';
            state.stu_id = stu_id ? stu_id : '';
        }
    },
    userReg: function userReg(state, data) {
        state.name = data.name;
        state.phone = data.phone;
        state.province_id = data.province_id;
        state.city_id = data.city_id;
        state.sex = data.sex;
        state.grade = data.grade;
        state.email = data.email;
        state.birth = data.birth;
    },
    userUpdate: function userUpdate(state, data) {
        state.name = data.hasOwnProperty('name') ? data.name : state.name;
        state.headimg = data.hasOwnProperty('head_pic') ? data.head_pic : state.headimg;
        state.phone = data.hasOwnProperty('phone') ? data.phone : state.phone;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province_name = data.hasOwnProperty('province_name') ? data.province_name : state.province_name;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.city_name = data.hasOwnProperty('city_name') ? data.city_name : state.city_name;
        state.area_code = data.hasOwnProperty('area_code') ? data.area_code : state.area_code;
        state.sex = data.hasOwnProperty('sex') ? data.sex : state.sex; // 1||2
        state.grade = data.hasOwnProperty('grade') ? data.grade : state.grade;
        state.email = data.hasOwnProperty('email') ? data.email : state.email;
        state.birth = data.hasOwnProperty('birth') ? data.birth : state.birth;
    },
    updateUName: function updateUName(state, data) {
        // 更新用户名
        state.name = data;
    },
    updateUserImg: function updateUserImg(state, data) {
        // 更新用户名
        state.headimg = data;
    },
    updateSex: function updateSex(state, data) {
        // 更新性别
        state.sex = data;
    },
    updateProvince: function updateProvince(state, data) {
        // 更新省份
        state.province_id = data;
    },
    updateCity: function updateCity(state, data) {
        // 更新城市
        state.city_id = data;
    },
    updateProvinceName: function updateProvinceName(state, data) {
        // 更新省份
        state.province_name = data;
    },
    updateCityName: function updateCityName(state, data) {
        // 更新城市
        state.city_name = data;
    },
    updateGrade: function updateGrade(state, data) {
        //更新年级
        state.grade = data;
    },
    updatePhone: function updatePhone(state, data) {
        // 更新手机
        state.phone = data;
    },
    updatePhoneCode: function updatePhoneCode(state, data) {
        state.phone_code = data;
    },
    updateMail: function updateMail(state, data) {
        //更新邮箱
        state.email = data;
    },
    updateBirth: function updateBirth(state, data) {
        //更新生日
        state.birth = data;
    },
    updateAreaCode: function updateAreaCode(state, data) {
        //更新地区码
        state.area_code = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_global__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_request__ = __webpack_require__(4);





// import axios from 'axios';

var urls = {
    wxauth: '/i/wechat/api/oauth',
    wxtoken: '/i/wechat/api/jsapi',
    wxauth21Days: '/i/day21/api/oauth',
    wxtoken21Days: '/i/day21/api/jsapi'
};

var actions = {
    wxUserAuth: function wxUserAuth(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["d" /* isWechat */]) {
            // wx 走授权
            var callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = '/i/wechat/api/oauth?callback_url=' + callback;
        } else {
            return;
        }
    },
    wxToken: function wxToken(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["d" /* isWechat */]) {
            // wx 走授权
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_util_request__["a" /* request */])({
                'url': urls.wxtoken,
                'params': data ? data : {}
            }).then(function (result) {
                var data = result.data ? result.data : {};
                // data 判断
                context.commit('wxTokenMutation', data);
                return result;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
            });
        } else {
            return;
        }
    },
    wxUserAuth21Days: function wxUserAuth21Days(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["d" /* isWechat */]) {
            // wx 走授权
            var callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = '/i/day21/api/oauth?callback_url=' + callback;
        } else {
            return;
        }
    },
    wxtoken21Days: function wxtoken21Days(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["d" /* isWechat */]) {
            // wx 走授权
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_util_request__["a" /* request */])({
                'url': urls.wxtoken21Days,
                'params': data ? data : {}
            }).then(function (result) {
                var data = result.data ? result.data : {};
                // data 判断
                context.commit('wxtoken21DaysMutation', data);
                return result;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
            });
        } else {
            return;
        }
    },
    wxTokenMiniapp: function wxTokenMiniapp(context, data) {
        context.commit('wxtokenMiniappMutation', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(59);

var getters = {
    getUserId: function getUserId(state) {
        return state.id;
    },
    getOpenId: function getOpenId(state) {
        return state.openId;
    },
    getToken: function getToken(state) {
        return state.token;
    },
    getUserName: function getUserName(state) {
        return state.name;
    },
    getNickName: function getNickName(state) {
        return state.nickName;
    },
    getAvatar: function getAvatar(state) {
        return state.avatar;
    },
    getEmail: function getEmail(state) {
        return state.email;
    },
    getSex: function getSex(state) {
        return state.sex;
    },
    getCity: function getCity(state) {
        return state.city;
    },
    getProvince: function getProvince(state) {
        return state.province;
    },
    getCountry: function getCountry(state) {
        return state.country;
    },
    getWxConf: function getWxConf(state) {
        return state.wxConf;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(217);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    wxUserAuthInfo: function wxUserAuthInfo(state, data) {
        // 变更状态

    },
    wxTokenMutation: function wxTokenMutation(state, data) {
        state.appId = data.appId;
    },
    wxtoken21DaysMutation: function wxtoken21DaysMutation(state, data) {
        state.appId = data.appId;
    },
    wxtokenMiniappMutation: function wxtokenMiniappMutation(state, data) {
        state.appId = data.appId;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "body,html{margin:0;padding:0;width:100%;height:100%;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}*{-webkit-text-size-adjust:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}input,textarea{-webkit-user-select:auto;margin:0;padding:0;outline:none}#app{margin:0 auto;width:10rem;height:100%;font-family:Microsoft YaHei,arial,helvetica,sans-serif}.mint-msgbox-btn,.mint-msgbox-message,.mint-msgbox-title{font-size:16px}.mint-msgbox{width:80%}.mint-msgbox-btns{height:50px;line-height:50px}.mint-msgbox-btn{padding-top:5px}.mint-msgbox-message{padding:0 5px 8px;color:#333;line-height:1.6}.mint-msgbox-content .mint-msgbox-message{font-size:16px}.mint-msgbox-confirm{color:#46c281}.mint-msgbox{padding-top:12px}.mint-msgbox-cancel,.mint-msgbox-content{border-color:#e4e4e4}.mint-toast{z-index:9999999}.router-view{width:100%;height:100%}", ""]);

// exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64c0d396",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("no this page")])
},staticRenderFns: []}

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(224);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(26)("7ce25342", content, true);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(225);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(26)("f5913896", content, true);

/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[137]);


// WEBPACK FOOTER //
// static/js/app.98417ad130c102f2e9c5.js